import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
    fill="inherit"
  />,
  'DotMIcon',
  {viewBox: '0 0 24 24'},
)
